import React, {
  useState, useEffect, useContext, useMemo,
} from 'react'
import {
  TrackOrder as CPTrackOrder,
  OrderDetails as CPOrderDetails,
  BreadcrumbWidget,
} from '@usap/widgets'
import { useFeatureFlagCookieContext } from '@usap/core'
import { useResponsiveWrapperContext } from '@usap/uicomponents'
import queryString from 'query-string'

import captchConfig from '../../../config/captcha-config'

import { LocalContext } from '../../helpers/useLocalContext'
import trackMyOrder from '../../helpers/trackMyOrder'
import ReturnReasonUtils from '../../helpers/returnRequestUtils'
import { formatBrand } from '../../transformers/BrandText'
import { useTokenContext } from '../../contexts/token.context'
import OpenChat from '../Kustomer/Events'
import localConfig from '../../../config/local-config'
import { GTM, openSparkChatModal } from '../../helpers'
import { useDownloadPDF, useSparkChatEnabled } from '../../hooks'
import useWmoEnabled from '../../hooks/useWmoEnabled'
import { useOrderInvoiceDetails } from '../../hooks/useOrderInvoiceDetails'
import { getHardcodedRecomWidgets } from "../../helpers/getHardcodedRecomWidgets";
import { StaticPropsProvider } from '../../contexts/staticProps.context'

export default function TrackOrder({
  history,
  apiDetails,
  originalDynamicApiData
}) {
  const {
    trackOrder,
    orderDetail,
    credit_status: creditStatus,
    return_request_status: returnRequestStatus,
    props: staticProps,
    productProtectionPlan,
  } = apiDetails

  const { widgets, pageType } = originalDynamicApiData;
  const { apiDetails: recomApiDetails } = widgets.find(w => w.widget === "Recommendation") || {};
  const recomConfig = recomApiDetails.find(item => item.pageType === pageType);
  const pageRecommendationsSettings = recomConfig?.recommendationSettings;
  const recomStaticProps = recomConfig?.props;
const recommendationsComponent = getHardcodedRecomWidgets({ pageRecommendationsSettings })

  const { core, unfoldedShipping } = staticProps || {}

  const { isDesktop } = useResponsiveWrapperContext()
  const tokenDB = useTokenContext()

  const { localContext } = useContext(LocalContext)
  const { Link } = localContext

  const { covidMessage } = useFeatureFlagCookieContext()

  const [isTrackOrder, setIsTrackOrder] = useState(true)
  const [loading, setLoading] = useState(false)
  const [isPrintLoading, setIsPrintLoading] = useState(false)

  const [orderDetails, setOrderDetails] = useState('')
  const [orderInvoice, setOrderInvoice] = useState(null)
  const [print, setPrint] = useState(false)

  const [links, setLinks] = useState(trackOrder?.breadcrumb || [])

  const [error, setError] = useState('')
  const [emailAddress, setEmail] = useState('')
  const [merchantOrderId, setmerchantOrderId] = useState('')
  const isSparkChatEnabled = useSparkChatEnabled()

  const isCustomerTrackOrderRoute = typeof window === 'object' && window.location.href.indexOf('customer/trackorder') !== -1
  const isMyAccountTrackOrderRoute = typeof window === 'object' && window.location.href.indexOf('myaccount/trackorder') !== -1

  const { customTrackOrder, trackOrderPageLoaded : trackOrderPageLoadedGTM } = GTM

  const getMyOrder = (email, order, captcha) => {
    setLoading(true)
    setError('')
    trackMyOrder(email, order, null, null, captcha)
      .then(({ data }) => {
        if (data && data.data && data.data.orderDetails) {
          const details = data.data.orderDetails
          setOrderDetails(details)
          setIsTrackOrder(false)
          setEmail(email)
          setmerchantOrderId(order)
          customTrackOrder(details.merchantOrderId)
        } else {
          const err = data.errors[0].message
          setError(err)
        }
        setLoading(false)
      })
      .catch(err => {
        setError('Please Enter Valid Email Address/Order Number')
        setLoading(false)
        throw err
      })
  }

  const navigateToRMA = (oid, sku) => {
    history.push(
      `/myaccount/rma?emailAdd=${emailAddress}&orderId=${merchantOrderId}&sku=${sku}`,
    )
  }

  const printInvoice = () => {
    const content = document.getElementById('invoice').innerHTML
    const mywindow = window.open('', 'Print', 'height=700,width=1000')

    mywindow.document.write('<html><head><title>Invoice Print</title>')
    mywindow.document.write('</head><body>')
    mywindow.document.write(content)
    mywindow.document.write('</body></html>')

    mywindow.document.close()
    mywindow.focus()
    setTimeout(() => {
      mywindow.print()
      mywindow.close()
    }, 2000)

    return true
  }

  const isWmoEnabled = useWmoEnabled();
  const { downloadPDF, processingPDF: invoiceLoading } = useDownloadPDF();

  const { getGuestOrderInvoiceDetails } = useOrderInvoiceDetails();

  useEffect(() => {
    if (orderDetails)
      getInvoiceData();
  }, [orderDetails])

  const downloadInvoice = async () => {
    const { emailAddress: email, merchantOrderId: orderId } = orderDetails || {}
    if (!orderInvoice) await getInvoiceData(email, orderId);
    const content = document.getElementById("invoice").innerHTML;
    downloadPDF(content, `Invoice_${orderId}`);
  };

  const getInvoiceData = async (email, orderId) => {
    const data = await getGuestOrderInvoiceDetails(email, orderId);
    setOrderInvoice(data);
  }

  const handlePrintInvoice = () => {
    if (isWmoEnabled)
      downloadInvoice();
    else {
      setIsPrintLoading(true)
      const { emailAddress: email, merchantOrderId: orderId } = orderDetails || {}

      if (email && orderId && !orderInvoice) {
        setIsPrintLoading(true)
        setError('')
        trackMyOrder(email, orderId, true, false)
          .then(({ data }) => {
            if (data && data.data && data.data.orderDetails) {
              const details = data.data.orderDetails
              setOrderInvoice(details)
              setPrint(true)
            } else {
              const err = data.errors[0].message
              setError(err)
            }
            setIsPrintLoading(false)
          })
          .catch(err => {
            setError('Please Enter Valid Email Address/Order Number')
            setIsPrintLoading(false)
            throw err
          })
      } else {
        setIsPrintLoading(false)
        setPrint(true)
      }
    }
  }

  const openChatHandler = () => {
    if (isSparkChatEnabled) {
      openSparkChatModal();
    } else {   
      OpenChat();
    } 
  }

  useEffect(() => {
    if (print) {
      printInvoice();
      setPrint(false)
    }
  }, [print])

  useEffect(() => {
    if (isTrackOrder) {
      setLinks('' || [])
    } else {
      setLinks(orderDetail?.breadcrumb || [])
    }
  }, [isTrackOrder, orderDetail?.breadcrumb])

  useEffect(() => {
    if (__BROWSER__ && tokenDB && tokenDB.token_number) {
      history.push('/myaccount/orderhistory')
    } else {
      // For GTM Tracking - Track Order Page Loaded
      trackOrderPageLoadedGTM();
    }

    const parsed = queryString.parse(window.location.search)
    const { navigate } = parsed
    if (navigate) {
      setIsTrackOrder(true)
      history.push('/myaccount/trackorder')
    }
  }, [history, tokenDB])

  return (
    <StaticPropsProvider value={recomStaticProps || {}}>
      {!isCustomerTrackOrderRoute && !(isWmoEnabled && isMyAccountTrackOrderRoute) && <BreadcrumbWidget isDesktop={isDesktop} links={links} Link={Link} />}
      {isTrackOrder ? (
        <CPTrackOrder
          isDesktop={isDesktop}
          getMyOrder={getMyOrder}
          error={error}
          loading={loading}
          siteKey={captchConfig.siteKey}
          covidCookie={covidMessage}
          pushNotificationData={trackOrder?.pushNotificationData}
          recommendationsComponent={recommendationsComponent}
          chatAssistantData={trackOrder?.chatAssistant}
        />
      ) : (
        <CPOrderDetails
          isTrack="trackorderpage"
          isDesktop={isDesktop}
          Link={Link}
          returnReasonUtils={ReturnReasonUtils}
          orderDetails={orderDetails}
          creditStatus={creditStatus}
          returnRequestStatus={returnRequestStatus}
          orderInvoice={orderInvoice}
          handlePrintInvoice={handlePrintInvoice}
          invoiceLoading={invoiceLoading}
          isPrintLoading={isPrintLoading}
          print={print}
          navigateToRMA={navigateToRMA}
          covidCookie={covidMessage}
          formatBrand={formatBrand}
          coreConfig={core}
          OpenChatHandler={openChatHandler}
          isCustomerTrackOrderRoute={isCustomerTrackOrderRoute}
          config={localConfig}
          GTM={GTM}
          productProtectionPlan={productProtectionPlan}
          pushNotificationData={trackOrder?.pushNotificationData}
          recommendationsComponent={recommendationsComponent}
          unfoldedShippingConfig={unfoldedShipping}
        />
      )}
    </StaticPropsProvider>
  )
}
